module.exports = __webpack_public_path__ + "static/media/faces_img.900e51a7.png";